module.exports = __webpack_public_path__ + "media/images/gb-ec4b1b15e109f60db9ceddbdfd915a7f.svg";